<div class="container">
  <h1 class="title">{{ 'faqs.page.title' | translate : { fgbdefault: 'FAQS' } }}</h1>
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
